module.exports = __webpack_public_path__ + "static/img/315_TO8_2473.2e44bde.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/315_TO8_2473.jpg
// module id = 8qGx
// module chunks = 0